'use client';

import classNames from 'classnames';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import Image from '@alltrails/core/components/Image';
import Button from '@alltrails/denali/components/Button';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import type { ConditionStyleId } from '@alltrails/maps/types/Styles';
import groundConditionsSrc from './images/groundConditions.avif';
import precipitationSrc from './images/precipitation.avif';
import snowDepthSrc from './images/snowDepth.avif';
import temperatureSrc from './images/temperature.avif';
import styles from './TrailConditionsWeatherMapButton.module.scss';

type TrailConditionsWeatherMapButtonProps = {
  className?: string;
  condition: ConditionStyleId;
  onClick: () => void;
};

const TrailConditionsWeatherMapButton = ({ className, condition, onClick }: TrailConditionsWeatherMapButtonProps) => {
  const isMobile = useIsMobileSizedScreen();

  const src = useMemo(() => {
    switch (condition) {
      case 'groundConditions':
        return groundConditionsSrc;
      case 'precipitation':
        return precipitationSrc;
      case 'snowDepth':
        return snowDepthSrc;
      case 'temperature':
      default:
        return temperatureSrc;
    }
  }, [condition]);

  return (
    <Button
      className={classNames(styles.mapButton, className)}
      icon={<Image alt="" height={32} width={32} src={src} />}
      onClick={onClick}
      size={isMobile ? 'sm' : 'md'}
      testId="weather-map"
      text={<FormattedMessage defaultMessage="Weather map" />}
      variant="elevated"
    />
  );
};

export default TrailConditionsWeatherMapButton;
